import { Controller } from "@hotwired/stimulus";

/**
 * L'îlot d'une compo vierge (« Ajouter un visuel ») : deux formulaires, une même naissance du
 * document (POST documents#create, le kind se décide côté serveur).
 *  - « Importer un média » ouvre la modale bibliothèque de l'îlot ; les médias choisis
 *    remplissent le formulaire de l'îlot (content_medium_ids[]) et le soumettent UNE fois — la
 *    réponse recharge l'îlot avec ses pages, aucun état client. Un upload de plusieurs
 *    fichiers attend la fin de son lot (content_media:batch_selected, dans l'ordre de la
 *    sélection) : une requête par fichier, et chacune écrasait le document de la précédente.
 *  - « Créer ▾ » (Images, Vidéo) : des boutons de formulaire ordinaires, rien ici — le
 *    serveur seed, crée le brouillon et redirige vers « Quel format ? » dans le frame du
 *    panel (lib/frame_hosts l'ouvre).
 *
 * Naming: "composition-seed" in HTML.
 */
export default class extends Controller {
  static targets = ["form"];
  static values = { dialog: String };

  connect() {
    this.dialog = document.getElementById(this.dialogValue);
    // Un fichier d'un lot d'upload n'est pas une sélection : le lot entier suit.
    this.onSelected = (event) => {
      if (event.detail?.batch) return;
      this.seed([event.detail?.contentMedium?.id]);
    };
    this.onBatchSelected = (event) => this.seed(event.detail.contentMedia.map((cm) => cm.id));
    this.dialog?.addEventListener("content_medium:selected", this.onSelected);
    this.dialog?.addEventListener("content_media:batch_selected", this.onBatchSelected);
  }

  disconnect() {
    this.dialog?.removeEventListener("content_medium:selected", this.onSelected);
    this.dialog?.removeEventListener("content_media:batch_selected", this.onBatchSelected);
  }

  openLibrary() {
    window.openDialog(this.dialogValue);
  }

  // Un média sans id (le premier événement d'un export Canva, l'aperçu) n'est pas encore un
  // ContentMedium : on attend celui qui en porte un. Un lot entièrement en échec n'envoie rien.
  seed(contentMediumIds) {
    const ids = contentMediumIds.filter(Boolean);
    if (ids.length === 0) return;

    this.formTarget.querySelectorAll('input[name="content_medium_ids[]"]').forEach((input) => input.remove());
    ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "content_medium_ids[]";
      input.value = id;
      this.formTarget.append(input);
    });
    this.formTarget.requestSubmit();
  }
}
